<template>
    <div class="grid grid-flow-row gap-4">
        <div class="bg-white border p-5 rounded-md min-h-32 relative overflow-hidden">
            <p class="uppercase font-medium text-sm mb-3">Markets</p>
            <img src="@/assets/images/world-map.svg" class="opacity-50 absolute position-x-center -top-14" />
            <div class="relative h-4/5 flex flex-col justify-center items-center mb-4 text-neutral-500">
                <p v-for="country in markets.edges" :key="country.node.id" class="text-sm font-normal uppercase mb-2">
                    <span class="font-medium">({{ country.node.code }})</span> - {{ country.node.name }}
                </p>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
import { CountriesInterface } from '@/models/productBriefsInterface';

defineProps<{
    markets: CountriesInterface
}>();


</script>